import React, { useEffect } from "react";
import { Box, Typography, Container, Grid } from "@mui/material";
import CategoryTile from "./CategoryTile";
import HeroBanner from "./HeroBanner";

// Dummy categories (replace later with API fetch if needed)
const categories = [
  {
    title: "Specialty Cakes",
    description: "Custom-designed cakes for life's biggest moments.",
    image: "/images/shopPage/specialty-cakes.png",
    link: "/shop/cakes/specialty-cakes",
  },
  {
    title: "Standard Cakes",
    description: "Ready-to-go favorites for any occasion.",
    image: "/images/shopPage/standard-cakes.png",
    link: "/shop/cakes/standard-cakes",
  },
  {
    title: "Cheesecakes",
    description: "Rich, creamy cheesecakes made with love.",
    image: "/images/shopPage/cheesecakes.png",
    link: "/shop/cakes/cheesecakes",
  },
  {
    title: "Patisserie",
    description: "Cupcakes, macarons, cookies, and more.",
    image: "/images/shopPage/patisserie.png",
    link: "/shop/patisserie",
  },
  {
    title: "Gift Boxes",
    description: "Delightful dessert boxes for every occasion.",
    image: "/images/shopPage/gift-boxes.png",
    link: "/shop/gift-boxes",
  },
  {
    title: "Accessories",
    description: "Candles, toppers, and celebration essentials.",
    image: "/images/shopPage/accessories.png",
    link: "/shop/accessories",
  },
];

const ShopPage = () => {
  useEffect(() => {
    document.title = "Shop";
  }, []);

  return (
    <Box>
      <HeroBanner />

      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Typography variant="h4" fontWeight="bold" align="center" gutterBottom>
          Shop by Category
        </Typography>

        <Box
          id="categories"
          sx={{
            mt: { xs: 2, md: 6 },
            scrollMarginTop: { xs: "200px", md: "250px" },
          }}>
          <Grid container spacing={4} mt={2}>
            {categories.map((cat) => (
              <Grid item xs={12} sm={6} md={4} key={cat.title}>
                <CategoryTile {...cat} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ShopPage;
